// @ts-strict-ignore
import { BaseArticleLocationProcessor } from './base-article-location.processor';
import { IArticleLocationProcessor, InsertedArticleData } from './i-article-location.processor';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { GenericArticleInsertProcessor } from './prepare/insert/generic-article-insert.processor';
import { CentreArticleLocationVO } from '../model/vo/centre-article-location.vo';
import { ArticleVO } from '@article/model/vo/article.vo';
import { InsertArticleHelperFactory } from '@article/helper/insert-article-helper.factory';
import { ArticleManager } from '@article/manager/article.manager';
import { ProjectHelper } from '@project/helper/project.helper';
import { ProjectModel } from '@project/model/project.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleInsertProcessorRegistry } from './prepare/insert/article-insert-processor-registry';
import { ReplaceBusbarArticleHelper } from '@article/helper/replace/busbar/replace-busbar-article.helper';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { AddArticleError } from './add-article-error';

/**
 * Location processor for adding any article at the origin of the coordinate system without considering any connections.
 */
export class AddArticleInCentreProcessor extends BaseArticleLocationProcessor<CentreArticleLocationVO> implements IArticleLocationProcessor {

  constructor(
    articleLocation: CentreArticleLocationVO,
    article: ArticleVO,
    projectModel: ProjectModel,
    articleManager: ArticleManager,
    insertProcessorRegistry: ArticleInsertProcessorRegistry,
    replaceBusbarHelper: ReplaceBusbarArticleHelper,
    projectHelper: ProjectHelper,
    localeResourceManager: LocaleResourceManager,
    connectionInfoService: ConnectionInfoService,
    insertArticleHelperFactory: InsertArticleHelperFactory,
    private insertProcessor: GenericArticleInsertProcessor,
    private _succeedCB: () => void
  ) {
    super(
      projectModel,
      articleManager,
      insertProcessorRegistry,
      projectHelper,
      localeResourceManager,
      articleLocation,
      article,
      connectionInfoService,
      replaceBusbarHelper,
      insertArticleHelperFactory,
    )
  }

  public async process(): Promise<InsertedArticleData> {
    await super.loadFullArticle();
    await super.createAndRefreshWrapper(this.insertProcessor);
    return this.insertArticle();
  }

  private async insertArticle(): Promise<InsertedArticleData> {
    try {
      this.insertProcessor.process(
        this._articlesWrapper.articleContainers,
        this._articlesWrapper.baseArticleContainers,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
      const data: InsertedArticleData = {
        baseArticleGUID: this._articlesWrapper.baseArticleContainer.articleGUID,
        insertedArticleGUIDs: ArticleContainerUtils.extractArticleGUIDs(this._articlesWrapper.articleContainers),
        createUndoOperation: true,
        undoOperations: this._additionalUndoOperations,
        isAccessoriesAdded: false,
      };
      this._succeedCB();
      return data;
    } catch (error) {
      await super.processFailure(`Could not insert the article.`);
      throw new AddArticleError(error.message);
    }
  }
}
